(() => {
  const tidioOffsetStyleId = 'santa-tidio-mobile-offset';
  const tidioDefaultBottom = 28;
  const tidioCtaGap = 4;

  const getFloatingButtonHeight = () => {
    const button = document.querySelector('.floating-launch-button');

    return button ? Math.ceil(button.getBoundingClientRect().height) : 0;
  };

  const syncFloatingButtonHeight = () => {
    const buttonHeight = getFloatingButtonHeight();

    if (buttonHeight > 0) {
      document.documentElement.style.setProperty('--floating-launch-button-height', `${buttonHeight}px`);
      return;
    }

    document.documentElement.style.removeProperty('--floating-launch-button-height');
  };

  const getTidioBottomOffset = () => {
    const button = document.querySelector('.floating-launch-button');

    if (!button || button.classList.contains('is-hidden')) return tidioDefaultBottom;

    const buttonHeight = getFloatingButtonHeight();

    return Math.max(tidioDefaultBottom, buttonHeight + tidioCtaGap);
  };

  const getTidioOffsetStyle = () => `
    @media screen and (max-width: 749px) {
      #tidio-chat-root {
        bottom: ${getTidioBottomOffset()}px !important;
      }
    }
  `;

  const scrollToTarget = (target) => {
    const top = target.getBoundingClientRect().top + window.scrollY;

    window.scrollTo({
      top: Math.max(top, 0),
      behavior: 'smooth'
    });
  };

  const handleLaunchClick = (event) => {
    const link = event.target.closest('[data-floating-launch-link]');

    if (!link) return;

    const targetId = link.getAttribute('href')?.replace('#', '');
    const target = targetId ? document.getElementById(targetId) : null;

    if (!target) return;

    event.preventDefault();
    history.replaceState(null, '', `#${targetId}`);

    if (window.matchMedia('(max-width: 749px)').matches) {
      scrollToTarget(target);
      return;
    }

    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  const syncVisibilityWithTarget = () => {
    const button = document.querySelector('.floating-launch-button');
    const link = button?.querySelector('[data-floating-launch-link]');
    const targetId = link?.getAttribute('href')?.replace('#', '');
    const target = targetId ? document.getElementById(targetId) : null;

    if (!button || !target) return;

    const rect = target.getBoundingClientRect();
    const isTargetVisible = rect.top < window.innerHeight && rect.bottom > 0;

    button.classList.toggle('is-hidden', isTargetVisible);
    syncFloatingButtonHeight();
    applyTidioOffset();
  };

  const watchTargetVisibility = () => {
    syncVisibilityWithTarget();
    window.addEventListener('scroll', syncVisibilityWithTarget, { passive: true });
    window.addEventListener('resize', syncVisibilityWithTarget);
  };

  const watchFloatingButtonSize = () => {
    const button = document.querySelector('.floating-launch-button');

    if (!button) return;

    syncFloatingButtonHeight();

    if (!window.ResizeObserver) return;

    const observer = new ResizeObserver(() => {
      syncFloatingButtonHeight();
      applyTidioOffset();
    });

    observer.observe(button);
  };

  const applyTidioOffset = () => {
    const tidioHost = document.getElementById('tidio-chat');
    const tidioRoot = tidioHost?.shadowRoot;

    if (!tidioRoot) return false;

    let style = tidioRoot.getElementById?.(tidioOffsetStyleId) || tidioRoot.querySelector(`#${tidioOffsetStyleId}`);

    if (!style) {
      style = document.createElement('style');
      style.id = tidioOffsetStyleId;
      tidioRoot.appendChild(style);
    }

    style.textContent = getTidioOffsetStyle();

    return true;
  };

  const watchTidioOffset = () => {
    if (applyTidioOffset()) return;

    let attemptCount = 0;
    const maxAttempts = 40;

    let intervalId;
    let observer;

    const stopWatching = () => {
      window.clearInterval(intervalId);
      observer?.disconnect();
    };

    const retryTidioOffset = () => {
      if (applyTidioOffset()) {
        stopWatching();
        return;
      }

      attemptCount += 1;

      if (attemptCount >= maxAttempts) {
        stopWatching();
      }
    };

    intervalId = window.setInterval(retryTidioOffset, 500);
    observer = new MutationObserver(retryTidioOffset);

    observer.observe(document.body, { childList: true, subtree: true });
  };

  document.addEventListener('click', (event) => {
    if (event.target.closest('[data-floating-launch-link]')) {
      handleLaunchClick(event);
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      watchTargetVisibility();
      watchFloatingButtonSize();
      watchTidioOffset();
    }, { once: true });
    return;
  }

  watchTargetVisibility();
  watchFloatingButtonSize();
  watchTidioOffset();
})();
